// 멤버 프리뷰 경로 판별 (#869).
//
// 로그인·마이페이지 화면에서는 퀵메뉴와 모바일 푸터를 숨긴다. 구로에만 있던
// lib/member-preview-route.js 를 공유로 옮겼다 — 그 모듈을 쓰는 컴포넌트가
// 지점마다 따로 있어서 접을 수 없었다.
//
// 라우트가 없는 지점에서는 이 함수가 언제나 false 다. 그래서 전 지점이 같은
// 컴포넌트를 써도 동작이 변하지 않는다.

export function stripLocalePrefix(pathname = "/") {
  return (pathname || "/").replace(/^\/(ko|en|ja|zh|th)(?=\/|$)/, "") || "/";
}

export function isMemberPreviewPath(pathname = "/") {
  const normalized = stripLocalePrefix(pathname);
  return /^\/(main\/)?(login|mypage)(\/|$)/.test(normalized);
}
